import type { Maybe, ValueEvent } from '@adornis/base/utilTypes.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { injectAttributesOf } from '@adornis/chemistry/directives/inject-attributes.js';
import { FormField } from '@adornis/formfield/form-field.js';
import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { Product } from '../../db/product/Product.js';
import { getAllProducts } from '../../db/product/queries/getAllProducts.js';
import '../theme/d-dropdown-search-selection.js';

@customElement('d-product-picker')
export class DProductPicker extends FormField<Maybe<string>> {
  @state() private readonly _products = new RXController(this, getAllProducts()(Product.allFields));

  override render() {
    return html`
      <d-dropdown-search-selection
        .value=${this._products.value?.find(p => p.id === this.value.value)}
        ?disabled=${this._products.isLoading}
        placeholder=${this.getAttribute('placeholder') ?? 'Produkt'}
        .renderString=${(p: Product) => p?.name}
        .search=${search => {
          const products = this._products.value ?? [];
          if (!search) products;
          return products.filter(p => p.name.toLowerCase().includes(search.toLowerCase()));
        }}
        @value-picked=${(e: ValueEvent<Maybe<Product>>) => {
          this.value.next(e.detail.value?.id ?? null);
          this.dispatchEvent(new CustomEvent('value-picked', { detail: { value: this.value.value } }));
        }}
        ${injectAttributesOf(this)}
      >
      </d-dropdown-search-selection>
    `;
  }
}
